import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ButtonLink } from '@rikstv/play-common/src/components/button/ButtonLink';
import { DialogProps } from '@rikstv/play-common/src/components/coverPage/coverpage.types';
import { PlayerDialog } from '@rikstv/play-common/src/components/playerDialog';
import { commonSignUp } from '@rikstv/play-common/src/forces/loadUserInfo/actions';
import { authService } from '@rikstv/play-common/src/utils/auth/AuthService';

const handleLoginClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
  e.preventDefault();
  authService.login();
};

export const PlayerSignupDialog: React.FC<DialogProps['Signup']> = ({ posterUrl }) => {
  const dispatch = useDispatch();
  const dispatchSignupAction = useCallback(() => dispatch(commonSignUp({ fromAssetId: undefined })), [dispatch]);
  const heading = 'Se dette og mye mer';
  const footer = (
    <div>
      Allerede kunde?{' '}
      <ButtonLink onClick={handleLoginClick} to="#" buttonStyle="inline-link">
        Logg inn
      </ButtonLink>
      !
    </div>
  );

  return (
    <PlayerDialog
      heading={heading}
      linkOrClickHandler={dispatchSignupAction}
      buttonText="Bli kunde"
      posterUrl={posterUrl}
      footer={footer}
    />
  );
};
